import { useEffect, useRef } from 'react';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
};
export default usePrevious;
//# sourceMappingURL=usePrevious.js.map